import { useEffect } from 'react'
import { useNavigate, useRoutes, useLocation } from 'react-router-dom'

import Login from '../pages/login'

export const Guard = () => {
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const routes = useRoutes([{ path: '/login', element: <Login /> }])

  useEffect(() => {
    if (!routes) {
      window.sessionStorage.setItem(
        'redirectTo',
        JSON.stringify({ pathname, t: new Date().getTime() }),
      )
      navigate('/login')
    }
  }, [navigate, routes, pathname])

  return routes
}
